import { useGalleryUrl } from 'client/hooks/useGalleryUrl'
import { useSearchParams } from 'client/hooks/useSearchParams'

export const usePaginationLink = (page: number): string => {
  const searchParams = useSearchParams()

  const galleryUrl = useGalleryUrl()

  searchParams.forEach((value, key) => {
    galleryUrl.searchParams.set(key, value)
  })

  galleryUrl.searchParams.delete('page')
  galleryUrl.searchParams.delete('qv')

  if (page > 1) {
    galleryUrl.searchParams.set('page', page.toString())
  }

  return galleryUrl.toString()
}
